import { HSpacer, Text } from '@/components/DesignSystem';
import Computer from '@mui/icons-material/Computer';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const TestUserBadge = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" flexDirection="row">
      <Computer color="info" sx= {{ height: "16px", width: "16px" }} />
      <HSpacer size="2" />
      <Text category="overline" color="info">{t($ => $.shared.testUser.badge)}</Text>
      <HSpacer size="5" />
    </Stack>
  );
};
